import * as React from 'react';

import { Box, Typography } from '@mui/material';

import { FormSubmissionConditions } from './conditions/FormSubmissionConditions';
import { GenericConditions } from './conditions/GenericConditions';
import { useRuleStore } from '../../state/ruleStore';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';

import type { Plugin } from '../../hooks/useAutomationDefinitions';

type Props = { plugin: Plugin };

/**
 * Componente principal para o passo de Condições
 * Renderiza o componente correto baseado no event_type do trigger selecionado
 */
export const ConditionsStep: React.FC<Props> = ({ plugin }) => {
  const theme = useThemeContext();
  const { selectedTrigger } = useRuleStore();

  console.log('🔍 ConditionsStep - selectedTrigger:', selectedTrigger);
  console.log('🔍 ConditionsStep - event_type:', selectedTrigger?.event_type);

  if (!selectedTrigger) {
    return (
      <Box py={2}>
        <Box
          sx={{
            p: 3,
            backgroundColor: theme.background.secondary,
            borderRadius: 1,
            textAlign: 'center',
          }}
        >
          <Typography variant="body1" sx={{ color: theme.text.secondary }}>
            Selecione um gatilho na aba Geral para configurar as condições.
          </Typography>
        </Box>
      </Box>
    );
  }

  const eventType = selectedTrigger.event_type;
  const eventName = selectedTrigger.name;

  switch (eventType) {
    case 'form_submission':
      return <FormSubmissionConditions plugin={plugin} />;

    case 'event_created':
    case 'event_participant_added':
    case 'network_edge_created':
    case 'user_course_created':
    case 'course_created':
      return <GenericConditions plugin={plugin} eventType={eventType} eventName={eventName} />;

    default:
      console.warn(`⚠️ Event type desconhecido: ${eventType}`);
      return <GenericConditions plugin={plugin} eventType={eventType || 'unknown'} />;
  }
};
